import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';

export interface NewsDialogData {
  title: string;
  isImage: boolean;
  embedUrl?: SafeResourceUrl;
  imageUrl?: string;
}

@Component({
    selector: 'app-news-dialog',
    standalone: true,
    imports: [MatDialogModule],
    templateUrl: './news-dialog.component.html',
    styleUrls: ['./news-dialog.component.css'],
})
export class NewsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewsDialogData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}